import React, { useContext, useEffect, useRef, useState } from "react";

import { CardContent, LinearProgress, Typography } from "@mui/material";
import { Stack } from "@mui/system";

import { getLoneworkerOrgSettings } from "../../../../api/endpoints/lone-worker";
import { callOptionsHeaders } from "../../../../api/helpers";
import { SnackbarContext } from "../../../../context/snackbar-context";
import SettingsMonitoring from "./monitoring";
import { SettingsContext } from "./settings-context";

interface Props {
  roleId: string;
  regionCode: string;
}

const Settings = (props: Props) => {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const { showError } = useContext(SnackbarContext);
  const {
    setRoleId,
    setMonitoringSeatsTotal,
    setMonitoringSeatsUsed,
    setMonitoringCompany,
    setRegionCode,
  } = useContext(SettingsContext);

  setRegionCode(props.regionCode);
  setRoleId(props.roleId);

  const getLoneWorkerSettings = useRef(() => {
    setIsLoading(true);
    getLoneworkerOrgSettings(
      props.roleId,
      callOptionsHeaders(props.regionCode, props.roleId)
    )
      .then((res) => {
        setMonitoringCompany(res.monitoringCompany);
        setMonitoringSeatsUsed(res.monitoringSeatsUsed);
        setMonitoringSeatsTotal(res.monitoringSeatsTotal);
        setIsLoading(false);
      })
      .catch(showError);
  });

  useEffect(() => {
    getLoneWorkerSettings.current();
  }, []);

  return (
    <>
      {isLoading ? (
        <LinearProgress data-testid="settings-is-loading-progress" />
      ) : (
        <Stack direction="column">
          <CardContent>
            <Typography variant="h6">Lone Worker Settings</Typography>
          </CardContent>
          <SettingsMonitoring />
        </Stack>
      )}
    </>
  );
};

export default Settings;
